import { Injectable } from "@angular/core"
import { DisplayDataResolver } from "@pl/pl-lib/common"
import { isEmpty } from "lodash"
import { Job } from "../../models/job"

@Injectable({
  providedIn: "root",
})
export class JobDisplayDataResolver implements DisplayDataResolver<Job> {
  typeDisplayName = "Job"

  constructor() {}

  getIcon(entity: Job): string | undefined {
    return "k-i-inherited"
  }

  getImage(entity: Job): string | undefined {
    return undefined
  }

  getSubTitle(entity: Job): string | undefined {
    return undefined
  }

  getTitle(entity: Job): string {
    return entity.title
  }

  getShortTitle(entity: Job): string {
    return entity.id
  }

  getItemHref(entityOrID: Job | string): string | undefined {
    if (isEmpty(entityOrID)) {
      return "/app/job"
    }
    if (typeof entityOrID === "string") return "/app/job/" + entityOrID
    return "/app/job/" + entityOrID.id
  }
}
